var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgOnboardingPreviewAreaBg = function SvgOnboardingPreviewAreaBg(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 644,
    height: 960,
    viewBox: "0 0 644 960",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_608_555)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 644,
    height: 960,
    fill: "url(#paint0_linear_608_555)"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 657.975,
    y: 43.751,
    width: 247,
    height: 1264.27,
    transform: "rotate(45 657.975 43.751)",
    fill: "url(#paint1_linear_608_555)"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 480.726,
    y: -332,
    width: 247,
    height: 1073,
    transform: "rotate(45 480.726 -332)",
    fill: "url(#paint2_linear_608_555)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_608_555",
    x1: 545.5,
    y1: 28,
    x2: 0.353903,
    y2: 1033.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_608_555",
    x1: 655.694,
    y1: 633.812,
    x2: 907.037,
    y2: 619.391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F6F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_608_555",
    x1: 478.445,
    y1: 168.791,
    x2: 729.468,
    y2: 151.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F6F8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_608_555"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 644,
    height: 960,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgOnboardingPreviewAreaBg);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "onboarding-preview-area-bg.3bcfdd179ad20d8d3b39b2a8653b5463.svg";